import React from "react";
import * as styles from "../BulkUpdate.module.scss";

export default class SimpleField extends React.Component {
  handleChangeValue = (e) => {
    const { onChangeValue, fieldInfo } = this.props;
    let value = e.target.value;
    if (fieldInfo.name === "status") value = value.toLowerCase();

    onChangeValue({ value });
  };

  render() {
    const { value, policy, fieldInfo, onChangePolicy } = this.props;
    const inputId = `bulk-update-field-input-${fieldInfo.name}`;
    const selectId = `bulk-update-field-select-${fieldInfo.name}`;

    return (
      <div>
        <div>
          <label
            htmlFor={inputId}
          >{`Please enter the text you wish to add to “${fieldInfo.label}”:`}</label>
          <input
            id={inputId}
            className={styles.input}
            onChange={this.handleChangeValue}
            value={value}
          />
        </div>

        <div className={styles.policy}>
          <label htmlFor={selectId}>What would you like to do?</label>
          <select
            id={selectId}
            className={styles.select}
            value={policy}
            onChange={onChangePolicy}
          >
            <option value="replace">
              Delete existing text and REPLACE with new text
            </option>
            <option value="emptyOnly">
              Replace the contents of EMPTY fields only
            </option>
          </select>
        </div>
      </div>
    );
  }
}
